export * from './squad.component';
